import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';

const BlogPost = ({ id }) => {
  const [blogPost, setBlogPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBlogPost = async () => {
      try {
        const response = await axios.get(`https://api.haulradar.com/v1/blog/blogpost/${id}`);
        setBlogPost(response.data.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch the blog post.');
        setLoading(false);
      }
    };

    fetchBlogPost();
  }, [id]);

  if (loading) {
    return <p className="text-center text-gray-500">Loading...</p>;
  }

  if (error) {
    return <p className="text-center text-red-500">{error}</p>;
  }

  if (!blogPost) {
    return <p className="text-center text-gray-500">No blog post found.</p>;
  }

  // Sanitize the content
  const cleanHTML = DOMPurify.sanitize(blogPost.content);

  return (
    <section className="bg-gray-200 py-10">
      <div className="container mx-auto px-6">
        <div className="bg-white p-8 rounded-lg shadow-lg">
          {/* Display the blog post title */}
          <h1 className="text-4xl font-bold text-black mb-4">{blogPost.title}</h1>
          
          {/* Display the creation date */}
          <p className="text-gray-500 mt-2 mb-6">Published on: {new Date(blogPost.created_at).toLocaleDateString()}</p>
          
          {/* Render HTML content and apply spacing using Tailwind */}
          <div
            className="mt-6 text-gray-800 space-y-6"  // Use space-y-6 for vertical spacing between elements
            dangerouslySetInnerHTML={{ __html: cleanHTML }}
          />
        </div>
      </div>
    </section>
  );
};

export default BlogPost;
